import React, { Component } from 'react';
import { getWorkWithUsList, removeWorkUsItem } from '../../modules/Api';
import ReactTable from 'react-table';
import moment from 'moment-jalaali';
import { Button } from 'antd';
import history from '../../modules/History';
import ACL from '../../components/ACL';
import {notification} from 'antd';

class WorkWithUs extends Component {
    constructor() {
        super();
        this.state = {
            data: [],
            last_page: 1,
            count: 0,
            pageSize: 15,
        }
    }

    componentDidMount() {
        //this.fetchData();
    }

    fetchData = (query = '') => {
        getWorkWithUsList(query, (res) => {
            this.setState({
            data     : res.data,
            count    : res.total,
            last_page: res.last_page,
            pageSize : res.pageSize
        })});
    }
    removeWorkUs(id) {
        const warningMessage = `آیا از حذف اطلاعات اطمینان کامل دارید ؟ تمام اطلاعات مرتبط با آن حذف می شوند !`;
        const that = this;
        if (window.confirm(warningMessage)) {
            removeWorkUsItem(id, () => {
                notification.open({
                    message: `حذف شد!`,
                });

                that.fetchData('')
            })
        }
    }

    onChange(state) {
        this.setState({pageSize: state.pageSize});
        const brand  = state.filtered.find(f => f.id === 'brand') ? state.filtered.find(f => f.id === 'brand').value : '';
        const domain  = state.filtered.find(f => f.id === 'domain') ? state.filtered.find(f => f.id === 'domain').value : '';

        const query = `page=${state.page  + 1}&per_page=${state.pageSize}&brand=${brand}&domain=${domain}`;
        this.fetchData(query);
    }

    render() {
        const columns = [
            {
                Header: 'آیدی',
                accessor: 'id',
            },
            {
                Header: 'نام برند',
                accessor: 'brand',
                filterable: true,
                Cell: row => (<span title={row.original.brand}> {row.original.brand} </span>)
            },
            {
                Header: 'نام دامنه',
                accessor: 'domain',
                id: 'domain',
                filterable: true,
                Cell: (row) => (<span title={row.original.domain}> {row.original.domain}</span>)
            },
            {
                Header: 'نام فرستنده',
                accessor: 'name',
                Cell: (row) => (<span title={row.original.name}> {row.original.name} </span>)
            },
            {
                Header: 'شماره تماس',
                accessor: 'phone',
                Cell: (row) => (<span title={row.original.phone}> {row.original.phone} </span>)
            },
            {
                Header: 'ایمیل',
                accessor: 'email',
                Cell: (row) => (<span title={row.original.email}> {row.original.email} </span>)
            },
            {
                Header: 'متن پیام',
                accessor: 'text',
                id: 'text',
                Cell: (row) => (<span title={row.original.text}> {row.original.text}</span>)
            },
            {
                Header: 'حذف',
                accessor: 'delete',
                Cell: (row) => (<ACL component="span" has_permission="workus_management|workus_delete"><span onClick={() => {this.removeWorkUs(row.original.id)}} className="fa fa-trash" style={{color: 'tomato', cursor: 'pointer', marginTop: '20%'}} >X </span></ACL>)
            },
            {
                Header: 'تاریخ ایجاد',
                accessor: 'created_at',
                Cell: (row) => (
                    <React.Fragment>
                        <span>{moment(row.original.created_at).format('jYYYY/jMM/jDD')}</span>
                        <ACL component="span" has_permission="workus_management|workus_history"><span onClick={() => history.item.push(`/history/workwithus/${row.original.id}`)} className="link">H</span></ACL>
                    </React.Fragment>
                )
            },
        ]
        return(
            <div style={{textAlign: 'center'}}>
                <ACL component="span" has_permission="workus_management|workus_history"><Button type="secondary" className="mb" onClick={() => history.item.push(`/history/workwithus`)}>تاریخچه تغییرات</Button></ACL>
                <ReactTable
                    data={this.state.data}
                    columns={columns}
                    manual
                    onFetchData={state => this.onChange(state)}
                    defaultPageSize={this.state.pageSize}
                    pages={this.state.last_page}/>
            </div>
        );
    }
}

export default WorkWithUs;


// WEBPACK FOOTER //
// ./src/containers/WorkWithUs/index.js